import { Button, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, UseDisclosureProps, useToast } from "@chakra-ui/react"
import _ from "lodash"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { callMethod } from "../../../../../actions"
import { PROGRAM } from "../../../../../consts/methods.consts"
import { ATTENDANCE_TAGS, DROPDOWN_TAGS, MODULE_ASSESMENT_RESULT_TAGS, MODULE_ENROLLMENT_TAGS, PROGRAM_TAGS } from "../../../../../consts/tags.consts"
import { usePostMutation } from "../../../../../services/api.service"
import { ToastService } from "../../../../../services/toast.service"
import { showConfirmDialog } from "../../../../../store/reducers/confirm-modal"
import { customeJsonParser } from "../../../../../utils/utils"
import StudentTab from "./StudentTab"
interface UserSelectorProps {
    isOpen: UseDisclosureProps["isOpen"],
    onClose: UseDisclosureProps["onClose"] | undefined,
    setSelectedItems?: any
    parentData: any
    selectedItems?: any
}

const StudentSelector = ({ isOpen = false, onClose = () => { }, parentData }: UserSelectorProps) => {
    const [selected, setSelected] = useState<any>([]);
    const toast = new ToastService(useToast());
    const [create, { isLoading }] = usePostMutation();
    const dispatch: any = useDispatch()

    useEffect(() => {
        if (isOpen == true) {
            dispatch(callMethod(PROGRAM.GET_ENROLLED_STUDENTS_FOR_PROGRAM, parentData, [MODULE_ENROLLMENT_TAGS.LIST])).then((data: any) => {
                setSelected([...data])
            })
        }

    }, [isOpen])

    const onSaveHandler = () => {
        dispatch(
            showConfirmDialog({
                title: "Confirmation Required!",
                subtitle: (<div className="">
                    <p>
                        <span className=" text-red-500">Please note that if you enroll students from here,
                            all previous enrollments of the related modules will be removed and replaced with the new enrollments.
                        </span >
                    </p>
                    <p>Are you sure, you want to enrole selected students??</p>
                </div>),
                onConfirm: async () => {
                    if (_.isArray(selected) && selected?.length > 0) {
                        create({
                            method: PROGRAM.ENROL_STUDENTS_FROM_PROGRAM,
                            body: { data: selected, ...parentData },
                            invalidatesTags: [PROGRAM_TAGS.MODULE_ENROLMENT, MODULE_ENROLLMENT_TAGS.VIEW, MODULE_ENROLLMENT_TAGS.LIST, DROPDOWN_TAGS.LIST, MODULE_ASSESMENT_RESULT_TAGS.LIST, ATTENDANCE_TAGS.LIST]
                        }).unwrap().then(() => {
                            toast.setTitle("Success").setDescription("Enrollments has been created successfully.").showSuccessToast();
                            onClose();
                        }).catch((error: any) => {
                            let message = customeJsonParser(_.get(error?.data, '_server_messages', {}))
                            if (message) toast.setTitle("Error").setDescription(customeJsonParser(message)?.message).showErrorToast();
                        })
                    } else {
                        toast.setTitle("Warning").setStatus("warning").setDescription("Please select at least one student").show();
                    }
                }
            }))
    }

    return (
        <Modal
            closeOnOverlayClick={false}
            isOpen={isOpen}
            motionPreset='slideInBottom'
            onClose={onClose}
            size={"5xl"}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Select Students</ModalHeader>
                <ModalCloseButton autoFocus={false} _focus={{ border: 'none' }} />
                <ModalBody pb={0}>
                    <StudentTab isOpen={isOpen} selected={selected} setSelected={setSelected} />
                </ModalBody>

                <ModalFooter>
                    <HStack spacing={3}>
                        <Button isLoading={isLoading} variant={"solid"} size={"sm"} w={20} colorScheme="teal" onClick={onSaveHandler}>Add</Button>
                        <Button disabled={isLoading} variant={"solid"} size={"sm"} colorScheme="red" onClick={onClose}>Cancel</Button>
                    </HStack>
                </ModalFooter>
            </ModalContent >
        </Modal >
    )
}


export default StudentSelector